import React from 'react'
import { PhotoLibraryOutlined, AddBoxOutlined } from '@material-ui/icons'
import { Main, Scrollable, SettingFormsWrapper } from '../../layouts'
import { CreateCapabilityForm } from '../../forms'
import { CombinedTitle, TabsHead, View, SettingsMenu } from '../../components'
import { CapabilitiesAllTab } from './CapabilitiesAllTab'

export interface ICapabilitiesPage {
  canViewCreateCapabilityPage: boolean
}

export const CapabilitiesPage = ({
  canViewCreateCapabilityPage,
}: ICapabilitiesPage) => (
  <Main
    sidebarSecondary={<SettingsMenu />}
    titleBlock={
      <>
        <CombinedTitle first="Capabilities" second="Management" />
        <TabsHead
          tabs={[
            {
              label: 'All',
              value: 'all-capabilities',
              icon: <PhotoLibraryOutlined />,
            },
            ...(canViewCreateCapabilityPage
              ? [
                  {
                    label: 'Create new',
                    value: 'create-new',
                    icon: <AddBoxOutlined />,
                  },
                ]
              : []),
          ]}
        />
      </>
    }
    helmet="Administration: Group Capabilities"
  >
    <View tab="all-capabilities">
      <Scrollable>
        <CapabilitiesAllTab />
      </Scrollable>
    </View>
    {canViewCreateCapabilityPage && (
      <View keep tab="create-new">
        <Scrollable>
          <SettingFormsWrapper>
            <CreateCapabilityForm />
          </SettingFormsWrapper>
        </Scrollable>
      </View>
    )}
  </Main>
)
